<!-- @prettier -->
<template>
  <ConfirmationModal
    :entity="publisher"
    :title="$t('DELETE_AFFILIATE_MODAL_TITLE')"
    :cancel-button-text="$t('DELETE_AFFILIATE_MODAL_CANCEL_ACTION')"
    :confirm-action-text="$t('DELETE_AFFILIATE_MODAL_CONFIRM_ACTION')"
    :confirm-button-loading="loadingDeletingPublisher"
    :show-cancel-button="showActions"
    :show-confirm-button="showActions"
    @confirm="confirmDelete"
    @close="closeDeleteModal"
  >
    <div v-if="!publisherReferences && loadingPublisherReferences">
      <Loader custom-class="size-sm" />
      <span
        v-html="$t(checkReferencesText, { publisherName: publisher.name })"
      ></span>
    </div>

    <p
      v-if="publisherReferences && !publisherReferences.hasReferences"
      v-html="
        $t('DELETE_AFFILIATE_MODAL_NONE_ASSOCIATION_TEXT', {
          publisherName: publisher.name
        })
      "
    ></p>

    <div v-if="publisherReferences && publisherReferences.hasReferences">
      <p
        v-html="
          $t('DELETE_AFFILIATE_MODAL_ASSOCIATION_TEXT', {
            publisherName: publisher.name
          })
        "
      ></p>
      <div class="well well-sm m-t-10 m-b-0">
        <div class="form-horizontal">
          <!-- campaigns -->
          <div
            class="row"
            v-if="
              publisherReferences.campaigns &&
                publisherReferences.campaigns.length > 0
            "
          >
            <label class="col-md-3 control-label">
              <strong>Campaigns</strong>
            </label>
            <div class="col-md-8">
              <ul class="list-unstyled form-control-static list-text-overflow">
                <li v-for="(campaign, index) in publisherReferences.campaigns">
                  <a
                    v-tooltip.right.hover="$t('VIEW_CAMPAIGN')"
                    :href="`#/dashboard/campaign/${campaign.campaignId}`"
                    target="_blank"
                  >
                    <span class="display-text" :title="campaign.campaignName">
                      {{ campaign.campaignName }}
                    </span>
                    <i class="fa fa-external-link m-l-5"></i>
                  </a>
                </li>
              </ul>
            </div>
          </div>

          <!-- Numbers -->
          <div
            class="row"
            v-if="
              publisherReferences.numbers &&
                publisherReferences.numbers.length > 0
            "
          >
            <label class="col-md-3 control-label">
              <strong>Numbers</strong>
            </label>
            <div class="col-md-8">
              <ul class="list-unstyled form-control-static list-text-overflow">
                <li
                  v-for="number in publisherReferences.numbers"
                  :key="number.id"
                >
                  <span class="display-text" :title="number.numberName">
                    {{ number.numberName }}
                  </span>
                </li>
              </ul>
            </div>
          </div>

          <!-- Number Pools -->
          <div
            class="row"
            v-if="
              publisherReferences.numberpools &&
                publisherReferences.numberpools.length > 0
            "
          >
            <label class="col-md-3 control-label">
              <strong>Number Pools</strong>
            </label>
            <div class="col-md-8">
              <ul class="list-unstyled form-control-static list-text-overflow">
                <li v-for="numberPool in publisherReferences.numberpools">
                  <a
                    v-tooltip.right.hover="
                      $t('DELETE_AFFILIATE_MODAL_VIEW_NUMBER_POOL')
                    "
                    :href="`#/dashboard/campaign/${numberPool.numberpoolId}`"
                    target="_blank"
                  >
                    <span
                      class="display-text"
                      :title="numberPool.numberpoolName"
                    >
                      {{ numberPool.numberpoolName }}
                    </span>
                    <i class="fa fa-external-link m-l-5"></i>
                  </a>
                </li>
              </ul>
            </div>
          </div>

          <!-- users -->
          <div
            class="row"
            v-if="
              publisherReferences.ringbausers &&
                publisherReferences.ringbausers.length > 0
            "
          >
            <label class="col-md-3 control-label">
              <strong>Users</strong>
            </label>
            <div class="col-md-8">
              <ul class="list-unstyled form-control-static list-text-overflow">
                <li v-for="user in publisherReferences.ringbausers">
                  <span class="display-text" :title="user.ringbauserName">
                    {{ user.ringbauserName }}
                  </span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>

      <!-- Keep Numbers -->
      <div
        class="well well-sm m-t-10 m-b-0"
        v-if="
          publisherReferences &&
            publisherReferences.numbers &&
            publisherReferences.numbers.length > 0
        "
      >
        <div class="row form-horizontal">
          <div class="col-md-3">
            <NzToggle v-model="keepNumbers" name="keepNumbers" />
          </div>
          <p
            class="col-md-6 form-control-static"
            v-html="$t('DELETE_AFFILIATE_KEEP_NUMBERS_TEXT')"
          ></p>
        </div>
      </div>
    </div>
  </ConfirmationModal>
</template>

<script>
import ConfirmationModal from '@/core/components/ConfirmationModal/ConfirmationModal';
import Loader from '@/core/components/Loader';
import sharedMessages from '@/core/locales';
import messages from '../locales';
import NzToggle from '@/core/components/nzToggle/nzToggle';

export default {
  name: 'PublisherDeleteModal',
  components: {
    ConfirmationModal,
    Loader,
    NzToggle
  },
  props: {
    publisher: {
      type: Object,
      default: function() {
        return {};
      }
    },
    publisherReferences: {
      type: Object,
      default: function() {
        return {};
      }
    },
    loadingDeletingPublisher: {
      type: Boolean,
      default: false
    },
    loadingPublisherReferences: {
      type: Boolean,
      default: false
    },
    checkReferencesText: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      keepNumbers: false
    };
  },
  computed: {
    showActions() {
      return !!this.publisherReferences;
    }
  },
  methods: {
    confirmDelete() {
      this.$emit('confirm', this.keepNumbers);
    },
    closeDeleteModal() {
      this.$emit('close');
    }
  },
  i18n: {
    messages,
    sharedMessages,
    locale: 'en'
  }
};
</script>
